import React from "react";
import "./Footer.css";
import footerLogo from "../../Images/cloudisianIcon.png";
import carrieLogo from "../../Images/mainlogo.png";
import facebook_icon from "../../Images/facebook_icon.png";
import twitter_icon from "../../Images/twitter_icon.png";
import instagram_icon from "../../Images/Instagram_icon.png";
import linkedin_icon from "../../Images/Linked_icon.png";

const Footer = () => {
  return (
    <footer className="footerContainer">
      <div className="footerSubContainer">
        {/* Logo & Description */}
        <div className="footerImg">
          <div className="footerLogoContainer">
            <img
              src={carrieLogo}
              alt="Carrie Restore Logo"
              className="carrieLogo"
            />
            <a href="https://cloudisian.net/">
              <img src={footerLogo} alt="Cloudisian Logo" />
          
            </a>
           
            
            
          </div>
           
          <p>
            Career Restorer equips individuals with industry-ready skills and
            guided placements, helping them restart, grow, and thrive in their
            professional journey.
          </p>
          <p>careerrestorer.com</p>

          {/* Social Icons */}
          <div className="footerImgIcon">
            <a
              href="https://www.linkedin.com/company/cloudisian/posts/?feedView=all"
              aria-label="LinkedIn"
            >
              <img src={linkedin_icon} alt="LinkedIn Icon" />
            </a>
            <a
              href="https://www.instagram.com/career_restorer/"
              aria-label="Instagram"
            >
              <img src={instagram_icon} alt="Instagram Icon" />
            </a>
            <a href="/" aria-label="Facebook">
              <img src={facebook_icon} alt="Facebook Icon" />
            </a>
            <a href="/" aria-label="Twitter">
              <img src={twitter_icon} alt="Twitter Icon" />
            </a>
          </div>
        </div>

        {/* Quick Links, Products, Services */}
        <div className="footerText">
          <div className="footerTextPart">
            <h5>Quick Links</h5>
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/job">Jobs</a>
            <a href="/resources">Resources</a>
            <a href="/placement">Placement</a>
            <a href="/training">Training</a>
            <a href="/partners">Partners</a>
          </div>
          <div className="footerTextPart">
            <h5>Jobs</h5>
            <a href="/jobSub">Jobs By Category</a>
            <a href="/jobSub">Qualification</a>
            <a href="/jobSub">Location</a>
          </div>
          <div className="footerTextPart">
            <h5>Resources</h5>
            <a href="/resources">Career Guides </a>
            <a href="/resources">Blog</a>
            <a href="/resources">Webinars</a>
            <a href="/resources">Jobs & Career Videos</a>
          </div>
          <div className="footerTextPart">
            <h5>Placement</h5>
            <a href="/placement">Job Support </a>
            <a href="/placement">Success Stories</a>
            <a href="/placement">Pan & World Wide</a>
          </div>
        </div>
      </div>

      <hr />

      {/* Bottom Links */}
      <div className="footerSubContainer2">
        <p>© 2025 Career Restorer All rights reserved</p>
        {/* <a href="/policy">Privacy Policy</a>
        <p>Cookies</p>
        <a href="/terms">Terms and Conditions</a> */}
      </div>
    </footer>
  );
};

export default Footer;
